module.exports = __webpack_public_path__ + "styleguide.ec47fe1b.webm";